import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { findBrandInsight, findTrendInsight } from '@services/trendResearch';

const useKeyDesigns = (
	keyType,
	queryParams,
	summaryCounts,
	summaryField,
	isPreferenceAndBrandSet,
	scrollRef
) => {
	const dispatch = useDispatch();
	const [page, setPage] = useState(null);
	const [designs, setDesigns] = useState([]);
	const [showHorizontalScroll, setShowHorizontalScroll] = useState(false);

	const fetchKeyDesigns = async (pageNumber) => {
		try {
			dispatch(openLoader());
			let params = `${queryParams}${queryParams === '' ? '?' : '&'}size=20&page=${pageNumber}&${[
				summaryField
			]}=${summaryCounts[summaryField]}`;
			const data =
				keyType === 'key-fabric'
					? await findBrandInsight(keyType, params)
					: await findTrendInsight(keyType, params);

			if (data.data.length > 0) {
				if (data.currentPage > 0) {
					setDesigns((prev) => [...prev, ...data.data]);
				} else {
					setDesigns(data.data);
				}
			}
			if (data.currentPage === 0 && data.data.length === 0) {
				setDesigns([]);
			}
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	useEffect(() => {
		if (
			page !== null &&
			isPreferenceAndBrandSet &&
			queryParams !== null &&
			[summaryField] in summaryCounts
		) {
			fetchKeyDesigns(page);
		}
	}, [page, queryParams, isPreferenceAndBrandSet, summaryCounts]);

	useEffect(() => {
		if (isPreferenceAndBrandSet && queryParams !== null && [summaryField] in summaryCounts) {
			setPage(0);
			if (scrollRef.current) {
				scrollRef.current.scrollLeft = 0;
			}
		}
	}, [queryParams, isPreferenceAndBrandSet, summaryCounts]);

	useEffect(() => {
		const handleScroll = () => {
			if (scrollRef.current) {
				const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
				if (scrollLeft + clientWidth >= scrollWidth) {
					setPage((prev) => prev + 1);
				}
			}
		};

		const scrollContainer = scrollRef.current;
		if (scrollContainer) {
			setShowHorizontalScroll(true);
			scrollContainer.addEventListener('scroll', handleScroll);
		}

		return () => {
			if (scrollContainer) {
				scrollContainer.removeEventListener('scroll', handleScroll);
			}
		};
	}, [designs.length]);

	return { designs, showHorizontalScroll };
};

export default useKeyDesigns;
